/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  type ActivatedRouteSnapshot,
  BaseRouteReuseStrategy,
  type DetachedRouteHandle,
} from '@angular/router';

/**
 * Custom route reuse strategy.
 * Used to enable certain routes to reuse the instance of the provided 'component'
 * instead of destroying and creating a new one.
 * Used in project's components, data connectors and pages routes.
 */
export class CustomRouteReuseStrategy extends BaseRouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {}
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return (
      future.routeConfig === curr.routeConfig ||
      (future.data.reuseRoute && future.component === curr.component)
    );
  }
}
